import { IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class DealContactsDealListItem {
    @IsString()
    contractTitle!: string;
    @IsString()
    contractrefnum!: string;
    @IsString()
    dealContactImage!: string;
    @IsString()
    dealType!: string;
    @IsString()
    startDate!: string;
}

export class DealContactListItem {
    @IsString()
    kontactId!: string;
    @IsString()
    contactImage!: string;
    @IsNumber()
    contactType!: number;
    @IsString()
    contactTypeDesc!: string;
    @IsString()
    kontactName!: string;
    @Type(() => DealContactsDealListItem)
    @ValidateNested()
    Deals!: DealContactsDealListItem[];
    @IsString()
    contactStatus!: string;
}

export class DealContactsListItem {
    @IsString()
    companyName!: string;
    @IsString()
    companyImage!: string;
    @Type(() => DealContactListItem)
    @ValidateNested()
    contacts!: DealContactListItem[];
}

export class ContactsListItem {
    @IsString()
    @IsOptional()
    contactCode!: string;
    @IsOptional()
    @IsString()
    contactName!: null | string;
    @IsOptional()
    @IsString()
    companyName!: any;
    @IsString()
    contactAddressLine1!: string;
    @IsString()
    contactAddressLine2!: string;
    @IsString()
    contactAddressLine3!: string;
    @IsString()
    contactAddressLine4!: string;
    @IsString()
    contactAddressNumber!: string;
    @IsString()
    contactPostCode!: string;
    @IsString()
    contactTelephone!: string;
    @IsString()
    contactTelephone2!: string;
    @IsString()
    contactTelephone3!: string;
    @IsString()
    contactTelephone4!: string;
    @IsNumber()
    contactTelephoneType!: number;
    @IsNumber()
    contactTelephone2Type!: number;
    @IsNumber()
    contactTelephone3Type!: number;
    @IsNumber()
    contactTelephone4Type!: number;
    @IsNumber()
    contactType!: number;
    @IsNumber()
    konAddId!: number;
    @IsNumber()
    projectContactId!: number;
    @IsNumber()
    projectId!: number;
    @IsString()
    contactTypeDesc!: string;
    @IsString()
    contactStatus!: string;
    @IsString()
    addEmail!: string;
    @IsString()
    kontactImage!: string;
    @IsString()
    kontactCode!: string;
    @IsNumber()
    kontactId!: number;
    @IsString()
    firstName!: string;
    @IsString()
    lastName!: string;
    contactStart!: any;
    contactEnd!: any;
    description!: any;
    @Type(() => IpiListItem)
    @ValidateNested()
    ipiList!: IpiListItem[];
    @Type(() => DealContactsListItem)
    @ValidateNested()
    dealContacts!: DealContactsListItem[];
}

export class ContactsList {
    @IsNumber()
    totalRows!: number;
    @IsString()
    firstName!: string;
    @IsString()
    lastName!: string;
    @IsNumber()
    kontactId!: number;
    @IsString()
    projectName!: string;
    @IsString()
    projectCode!: string;
    @IsString()
    projectType!: string;
    @IsString()
    licenseProjectType!: string;
    @IsString()
    creatorCode!: string;
    @IsOptional()
    creatorName!: any;
    @IsOptional()
    @IsString()
    creatorCompanyName!: any;
    @IsOptional()
    @IsNumber()
    creatorKonAddId!: any;
    @IsString()
    creatorAddressLine1!: string;
    @IsString()
    creatorAddressLine2!: string;
    @IsString()
    creatorAddressLine3!: string;
    @IsString()
    creatorAddressLine4!: string;
    @IsString()
    creatorAddressNumber!: string;
    @IsString()
    creatorPostCode!: string;
    @IsString()
    creatorTelephone!: string;
    @IsString()
    creatorTelephone2!: string;
    @IsString()
    creatorTelephone3!: string;
    @IsString()
    creatorTelephone4!: string;
    @IsNumber()
    creatorTelephoneType!: number;
    @IsNumber()
    creatorTelephone2Type!: number;
    @IsNumber()
    creatorTelephone3Type!: number;
    @IsNumber()
    creatorTelephone4Type!: number;
    @IsString()
    description!: string;
    @IsString()
    creatorEmail!: string;
    @Type(() => ContactsListItem)
    @ValidateNested()
    contacts!: ContactsListItem[];
    // @Type(() => DealContactsListItem)
    // @ValidateNested()
    dealContacts!: DealContactsListItem[];
    @IsString()
    creatorImage!: string;
    @Type(() => IpiListItem)
    @ValidateNested()
    ipiList!: IpiListItem[];
}

export class ContactsCreateList {
    kontactId!: any;
    kontactName!: any;
    firstName!: any;
    data!: any;
}

export class IpiListItem {
    @IsOptional()
    @IsString()
    additionalIpNumber!: string;
    @IsOptional()
    @IsString()
    affiliation!: string | null;
    @IsOptional()
    @IsString()
    affiliationCode!: string | null;
    @IsNumber()
    createdBy!: number;
    @IsString()
    iPNumber!: string;
    @IsOptional()
    @IsString()
    knownAs!: string | null;
    @IsString()
    kontactCode!: string;
    @IsNumber()
    kontacts_IPI_Id!: number;
    @IsNumber()
    modifiedBy!: number;
    @IsString()
    @IsOptional()
    modifiedDate!: string;
}

export class AKAsList {
    @IsOptional()
    @IsNumber()
    kontactAKAID!: number;
    @IsOptional()
    @IsNumber()
    projectId!: number;
    @IsOptional()
    @IsString()
    kontactCode!: string;
    @IsOptional()
    @IsString()
    aka!: string;
}
